/**
 * Тайлангийн хугацааны шүүлтүүр — УБ-ийн хуанлиар.
 *
 * Бүх муж ХАГАС НЭЭЛТТЭЙ: `[from, to)`. `to`-г API-д дамжуулахдаа
 * дуудагч 1ms хасна (`/reports/sales` нь `lte`-ээр харьцуулдаг).
 *
 * ⚠️ Харьцуулалт нь «ИЖИЛ ҮЕТЭЙ» (шийдвэр 2026-09-18): сарын 18-нд
 *    «Энэ сар» = 9/1–9/18 ба өмнөх нь 8/1–8/18, 8 сарын БҮТЭН сар биш.
 *    Бүтэн сартай харьцуулбал сарын дунд үргэлж хуурамч уналт гарна.
 *    Дашбоардын орлогын график (`revenueWindow`) өөр аргаар бодно.
 */
import { fromUlaanbaatar, ulaanbaatarDayStart, ulaanbaatarParts } from './revenue.js';
export const REPORT_PRESETS = ['today', 'yesterday', 'month', 'prev-month', 'year', 'custom'];
export function isReportPreset(v) {
    return typeof v === 'string' && REPORT_PRESETS.includes(v);
}
const DAY = 86_400_000;
const HOUR = 3_600_000;
/** `"2026-09-01"` → УБ-ийн тэр өдрийн 00:00 агшин. Буруу формат бол null. */
export function ulaanbaatarDateStart(key) {
    const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key);
    if (!m)
        return null;
    const [y, mo, d] = [Number(m[1]), Number(m[2]), Number(m[3])];
    // Date.UTC нь 2026-02-31-ийг 3 сар руу эргүүлдэг — тийм огноог хүлээж авахгүй
    const probe = new Date(Date.UTC(y, mo - 1, d));
    if (probe.getUTCMonth() !== mo - 1 || probe.getUTCDate() !== d)
        return null;
    return fromUlaanbaatar(y, mo, d);
}
const daysIn = (year, month) => new Date(Date.UTC(year, month, 0)).getUTCDate();
/**
 * Өмнөх хугацааны «мөн үе» — тухайн сар/жилийн ижил өдөр, цаг, минут.
 * Өдөр нь тэр сард байхгүй бол (3/31 → 2 сар, 2/29 → өнгөрсөн он)
 * сарын сүүлийн өдрийг бүтнээр нь авна.
 */
function sameMomentIn(now, year, month) {
    const p = ulaanbaatarParts(now);
    const last = daysIn(year, month);
    if (p.day > last)
        return new Date(fromUlaanbaatar(year, month, last).getTime() + DAY);
    // УБ-ийн offset бүхэл цаг тул цагийн доторх ms нь UTC-тэй ижил
    return new Date(fromUlaanbaatar(year, month, p.day, p.hour).getTime() + (now.getTime() % HOUR));
}
/**
 * Сонголтоос муж ба харьцуулах өмнөх мужийг гаргана.
 * `custom`-д `"YYYY-MM-DD"` хоёр огноо (хоёулаа оруулна). Буруу бол null.
 */
export function reportRange(preset, now, custom) {
    const p = ulaanbaatarParts(now);
    const today = ulaanbaatarDayStart(now);
    const monthStart = fromUlaanbaatar(p.year, p.month, 1);
    const prevY = p.month === 1 ? p.year - 1 : p.year;
    const prevM = p.month === 1 ? 12 : p.month - 1;
    const prevMonthStart = fromUlaanbaatar(prevY, prevM, 1);
    switch (preset) {
        case 'today':
            return { from: today, to: now, prevFrom: new Date(today.getTime() - DAY), prevTo: new Date(now.getTime() - DAY) };
        case 'yesterday': {
            const from = new Date(today.getTime() - DAY);
            return { from, to: today, prevFrom: new Date(from.getTime() - DAY), prevTo: from };
        }
        case 'month':
            return { from: monthStart, to: now, prevFrom: prevMonthStart, prevTo: sameMomentIn(now, prevY, prevM) };
        case 'prev-month': {
            const y2 = prevM === 1 ? prevY - 1 : prevY;
            const m2 = prevM === 1 ? 12 : prevM - 1;
            return { from: prevMonthStart, to: monthStart, prevFrom: fromUlaanbaatar(y2, m2, 1), prevTo: prevMonthStart };
        }
        case 'year': {
            const from = fromUlaanbaatar(p.year, 1, 1);
            const prevFrom = fromUlaanbaatar(p.year - 1, 1, 1);
            return { from, to: now, prevFrom, prevTo: sameMomentIn(now, p.year - 1, p.month) };
        }
        case 'custom': {
            const from = custom ? ulaanbaatarDateStart(custom.from) : null;
            const last = custom ? ulaanbaatarDateStart(custom.to) : null;
            if (!from || !last || last < from)
                return null;
            const to = new Date(last.getTime() + DAY);
            const len = to.getTime() - from.getTime();
            return { from, to, prevFrom: new Date(from.getTime() - len), prevTo: from };
        }
    }
}
//# sourceMappingURL=report-range.js.map